import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Create,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  Edit,
  Show,
  SimpleShowLayout,
  FunctionField,
  translate as t,
  ShowButton,
  DeleteButton,
  RefreshButton,
} from 'admin-on-rest';

import { Link } from 'react-router-dom';
import queryString from 'query-string';

import {
  List as MaterialList,
  ListItem,
  FlatButton,
  CardActions,
} from 'material-ui';

import CreateIcon from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/content/create';
import MenuListItemLink from '../components/MenuListItemLink';
import '../styles/model/chapter/styles.css';
import SlugLink from '../components/button/SlugLink';
import UrlParamsLinkButton from '../components/button/UrlParamLinkButton';
import EditButton from '../components/button/EditButton';
import lStorage from '../utils/localStorage';
import Delete from '../components/Overrides/mui/delete/Delete';


const anchorStyle = {
  float: 'right',
  textAlign: 'center',
};

const styles = {
  NestedListItem: {
    backgroundColor: 'rbga(0,0,0,0)',
    transition: 'none',
  },
  Button: {
    display: 'inline-block',
  },
  Icons: {
    color: 'red',
  },
  PseudoNavButtons: {
    backgroundColor: 'red',
  },
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

export const ChapterList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="title" />
      <ReferenceField label="Book" source="book" reference="books">
        <TextField source="title" />
      </ReferenceField>
      <EditButton {...props} />
    </Datagrid>
  </List>
);

const ChapterTitle = ({ record }) => (
  <span>{record ? `${record.title}` : ''}</span>
);

export const ChapterDelete = (props) => (
  <Delete {...props} redirect={lStorage.string.load('lastBook')} /> // the parent is book
);

const ChapterActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ShowButton basePath={basePath} record={data} />
    <DeleteButton basePath={basePath} record={data} />
    <RefreshButton />
  </CardActions>
);

export const ChapterCreate = t((props) => {
  const { bookId, bookName } = queryString.parse(props.location.search);
  const values = queryString.parse(props.location.search);
  return (
    <Create {...props} actions={<ChapterActions />} title={props.translate('create.item', { item: props.translate('academy.chapter') })}>
      <SimpleForm defaultValue={values}>

        <Link to="/books">
          <FlatButton primary>{props.translate('home')}</FlatButton>
        </Link>

        <Link to={`/books/${bookId}`}>
          <FlatButton primary>{bookName}</FlatButton>
        </Link>

        <ReferenceInput label={props.translate('academy.book')} source="bookId" reference="books" allowEmpty>
          <SelectInput defaultValue={values.bookName} optionText="title" />
        </ReferenceInput>

        <TextInput source="title" label={props.translate('academy.chapter')} />

      </SimpleForm>
    </Create>
  );
});

export const ChapterEdit = t((props) => {
  lStorage.string.save('lastBook', props.location.state);

  return (
    <Edit title={<ChapterTitle />} actions={<ChapterActions />} {...props}>
      <SimpleForm redirect="edit">
        <Link to="/books">
          <FlatButton primary>{props.translate('home')}</FlatButton>
        </Link>
        <SlugLink id="book._id" title="book.title" slug="books" />

        <ReferenceInput format={(book) => book && book._id} label={props.translate('academy.book')} source="book" reference="books" allowEmpty>
          <SelectInput defaultValue="book.title" optionText="title" optionValue="_id" />
        </ReferenceInput>

        <TextInput source="title" label={props.translate('academy.chapter')} />

        <UrlParamsLinkButton
          resourceType="pages"
          action="create"
          fields="bookId, bookName, chapterId, chapterName"
          values="book._id, book.title, _id, title"
          style={anchorStyle}
        >
          <FlatButton
            primary
            label={props.translate('create.item', { item: props.translate('academy.page') })}
            icon={<CreateIcon />}
          />
        </UrlParamsLinkButton>

        <UrlParamsLinkButton
          resourceType="questions"
          action="create"
          fields="bookId, bookName, chapterId, chapterName"
          values="book._id, book.title, _id, title"
          style={anchorStyle}
        >
          <FlatButton
            primary
            label={props.translate('create.item', { item: props.translate('academy.question') })}
            icon={<CreateIcon />}
          />
        </UrlParamsLinkButton>

        <FunctionField
          label={props.translate('academy.pages')}
          render={(record) =>
            record.pages && record.pages.map((page) => (
              <MaterialList>
                <PagesList page={{ ...page }} chapter={{ ...record }} {...props} />
              </MaterialList>)
            )
          }
        />

        <FunctionField
          label={props.translate('academy.questions')}
          render={(record) =>
            record.questions && record.questions.map((question) => (
              <MaterialList>
                <QuestionList question={{ ...question }} chapter={{ ...record }} {...props} />
              </MaterialList>)
            )
          }
        />
      </SimpleForm>
    </Edit>
  );
});

export const ChapterShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
    </SimpleShowLayout>
  </Show>
);

export const PagesList = ({ page: { title: pageTitle, _id: pageId }, ...props }) => (
  <ListItem
    primaryText={pageTitle}
    primaryTogglesNestedList
    nestedItems={[
      <ListItem style={styles.NestedListItem} key={1} className="ListItemParent">
        <MenuListItemLink
          to={{ pathname: `/pages/${pageId}`, state: { prevPath: props.location.pathname } }}
          onClick={() => { }}
          style={styles.Button}
        >
          <EditIcon style={styles.Icons} />
          <div>
            {props.translate('edit.item', { item: props.translate('academy.page') }).toUpperCase()}
          </div>
        </MenuListItemLink>
      </ListItem>,
    ]}
  >
  </ListItem>
);

export const QuestionList = ({ question: { question: questionTitle, _id: questionId }, ...props }) => (
  <ListItem
    primaryText={questionTitle}
    primaryTogglesNestedList
    nestedItems={[
      <ListItem style={styles.NestedListItem} key={questionId} className="ListItemParent">
        <MenuListItemLink
          to={{ pathname: `/questions/${questionId}`, state: { prevPath: props.location.pathname } }}
          onClick={() => { }}
          style={styles.Button}
        >
          <EditIcon style={styles.Icons} />
          <div>
            {props.translate('edit.item', { item: props.translate('academy.question') }).toUpperCase()}
          </div>
        </MenuListItemLink>
      </ListItem>,
    ]}
  >
  </ListItem>
);
